export const isBrowser = () => typeof window !== "undefined"

export const setId = id => window.localStorage.setItem("id", id);
export const getId = () => isBrowser() && window.localStorage.getItem("id");
export const getToken = () =>
  isBrowser() && window.localStorage.getItem("token")
    ? window.localStorage.getItem("token")
    : ''

export const getSukien = () =>
  isBrowser() && window.localStorage.getItem("dangKySuKien")
    ? window.localStorage.getItem("dangKySuKien")
    : ''

export const getMail = () => isBrowser() && sessionStorage.getItem('mail');

export const setMailService = (mail) =>isBrowser() && sessionStorage.setItem('mail', mail);

export const getHref = () =>
  isBrowser() && window.localStorage.getItem("href")
    ? window.localStorage.getItem("href")
    : ''

export const getDev = () =>
  isBrowser() && window.sessionStorage.getItem("dev")
    ? window.sessionStorage.getItem("dev")
    : ''

export const setToken = token => window.localStorage.setItem("token", token)
export const removeToken = () => window.localStorage.removeItem("token")

export const setSuKien = dangKySuKien => window.localStorage.setItem("dangKySuKien", dangKySuKien)
export const removeDangKySuKien = () => window.localStorage.removeItem("dangKySuKien")

export const setHref = href => localStorage.setItem("href", href)
export const removeHref = () => window.localStorage.removeItem("href")

export const setDev = dev => sessionStorage.setItem("dev", dev)
export const removeDev = () => window.sessionStorage.removeItem("dev")

export const callAPI = async (url, method, body) => {
  try {
      const response = await fetch(url, {
          method: method,
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
      });
      if (response.ok) {
          const data = await response.json();
          return data;
      } else {
          console.error('Error:', response.status);
      }
  } catch (error) {
      console.error('Error:', error);
  }
}


export const baseURL = 'http://id.myu.vn'
// export const baseURL = 'https://sandbox-id.myu.vn'

